import { axiosInstance } from "./axiosInstance";

export const voucherService = {
    getVoucher: async ( filters ) => {
        return await axiosInstance.get('/api/superadmin/voucher', { params: filters })
    },
    createVoucher: async (data) => {
        return await axiosInstance.post('/api/superadmin/voucher/create', data)
    },
    updateVoucher: async (id, data) => {
        return await axiosInstance.post(`/api/superadmin/voucher/update/${id}`, data)
    },
    deleteVoucher: async (id) => {
        return await axiosInstance.delete(`/api/superadmin/voucher/delete/${id}`)
    }
}
